module.exports = __webpack_public_path__ + "static/media/re.4fbc09c9.svg";